import ContainerHeader from "components/ContainerHeader"
import { connect } from "react-redux"
import { useEffect, useState } from "react"
import API from 'util/Api'
import CardBox from "components/CardBox"
import ReportFilter from "components/ReportTable/ReportFilter"
import moment from "moment"
import _ from "lodash"
import ReportTable from "components/ReportTable"

const Attendance = (props)=>{
    const reportFlags = _.find(props?.reportFlags, { name: 'attendance' })?.flags;
    const [valetLocations, setValetLocations] =  useState([])
    const [table, setTable] = useState({})
    useEffect(()=>{
        API.get("valetLocations").then((res) => {
			let valetLoc = [];
			res.data.data.table.body.map((loc)=> {
				let tempLoc={id:loc.id.value, name:loc.name.value};
				valetLoc.push(tempLoc);
			})
			setValetLocations(valetLoc)
		})
    },[])
    const getReportData = (params,cb)=>{
        params.type = 'attendance'
        API.get("reportDetails?data=" + JSON.stringify(params)).then((res) => {
            setTable(res.data.data || {})
            cb()
        }).catch(err=>{
            setTable({}) // Ensure table is set to empty object on error
            cb()
        })
    }
    console.log("valetLocations--",valetLocations,reportFlags)
    return <>
    <ContainerHeader title={"Attendance Report"} />
    <div className="row">
        <CardBox styleName="col-12">
            <ReportFilter
                locations={[]}
                valetLocations={valetLocations}
                reportType={'attendance'}
                requestStatus={{ msg: "", success: true }}
                getReportData={getReportData}
                flags={reportFlags}
                vendors={[]}
            />
        </CardBox>
        {table && Object.keys(table).length > 0 && (
            <ReportTable
                downloadCSVBtn
                data={table}
            />
        )}
    </div>
        </>
}
const mapStateToProps = function (state) {
    try {
        return {
            reportFlags: _.concat(
                state.auth.authUser.users
            ),
            dashboardActions: state.auth.authUser.dashboardactions,
        };
    } catch (err) { }
}
export default connect(mapStateToProps)(Attendance);